import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getApiUrl } from "../../ApplicationSettings.js";

function RedirectionToShortUrl() {
  const { shortcode } = useParams();

  useEffect(() => {
    let url = getApiUrl();
    window.location.href = `${url}/r/${shortcode}`;
  }, [shortcode]);

  return <></>;
}

export default RedirectionToShortUrl;
